/* globals $H,Class,jui,lp */

lp.editor.ComponentSideBar = Class.create(jui.Component, {
  options: function($super,options){
    return $super($H({attributes:{id:'component-side-bar', className: 'widget-panel'}}).merge(options));
  },

  initialize: function($super, options) {
    options = options || {};
    this.opening = false;

    $super(options);

    var self = this;

    this.e.observe('mouseover', function() {
      if (!self.e.hasClassName('open')) {
        self.e.addClassName('open');
      }
    });

    this.e.observe('mouseout', function() {
      if (self.e.hasClassName('open')) {
        self.e.removeClassName('open');
      }
    });

    if (options.left) {
      this.e.addClassName('left');
    }
  },

  installUI: function($super) {
    $super();
    this.content = this._insert(new jui.Component({attributes:{className:'content'}}));
  },

  insert: function(c){
    return this.content.insert(c);
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/component_side_bar.js
// module id = 1012
// module chunks = 0